import { isEmpty } from './isEmpty';
import { isNil } from './isNil';

export const isNilOrEmpty = (value: unknown): value is null | undefined | '' => {
  return isNil(value) || isEmpty(value);
};
